module.exports = __webpack_public_path__ + "img/scene5-10.e60a215c.png";